export default __webpack_public_path__ + "static/media/CurrentImg.7473b181.svg";